const END_OF_INPUT = '<|endofinput|>';

export interface QuotedMessageParts {
  quotedText: string;
  messageText: string;
}

/** Extract display/edit text without leaking message transport tags. */
export function splitQuotedMessage(content: string): QuotedMessageParts {
  const visibleContent = (content || '')
    .split(END_OF_INPUT)[0]
    .replace(/<resource_viewing>[\s\S]*?<\/resource_viewing>\n?/g, '');
  const quoteMatch = visibleContent.match(/^<quote>([\s\S]*?)<\/quote>\n?/);

  if (!quoteMatch) {
    return { quotedText: '', messageText: visibleContent };
  }

  return {
    quotedText: quoteMatch[1],
    messageText: visibleContent.slice(quoteMatch[0].length),
  };
}

export function joinQuotedMessage(quotedText: string, messageText: string): string {
  const quote = quotedText;
  const body = messageText;
  if (!quote.trim()) return body;
  return `<quote>${quote}</quote>${body ? `\n${body}` : ''}`;
}

export function getMessageTransportSuffix(content: string): string {
  const endOfInputIndex = content.indexOf(END_OF_INPUT);
  return endOfInputIndex === -1
    ? ''
    : content.slice(endOfInputIndex + END_OF_INPUT.length);
}

export function appendMessageTransportSuffix(content: string, suffix: string): string {
  return suffix ? `${content}${END_OF_INPUT}${suffix}` : content;
}
